import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import * as moment from "jalali-moment";
import helperNumber from "../../../helpers/numbers";
import Charge from "./Charge";
import User from "./User";

const startTime = () => {
  var today = new Date();
  var h = today.getHours();
  var m = today.getMinutes();
  var s = today.getSeconds();
  m = checkTime(m);
  s = checkTime(s);

  if (document.getElementById("clock-timer") != null) {
    document.getElementById("clock-timer").innerHTML =
      helperNumber.toPersianNum(h + ":" + m + ":" + s, false);
    var t = setTimeout(startTime, 500);
  }
};
const checkTime = (i) => {
  if (i < 10) {
    i = "0" + i;
  } // add zero in front of numbers < 10
  return i;
};

const getDayFullNamePer = () => {
  let dateNow = new Date();
  let days = new Array(7);
  days[0] = "یک شنبه";
  days[1] = "دوشنبه";
  days[2] = "سه شنبه";
  days[3] = "چهارشنبه";
  days[4] = "پنج شنبه";
  days[5] = "جمعه";
  days[6] = "شنبه";
  let dayName = days[dateNow.getDay()];
  return dayName;
};

const getDateNow = () => {
  const date = moment().format("jYYYY/jM/jD");

  const dateSplited = date.split("/");

  const year = helperNumber.toPersianNum(dateSplited[0]);
  const month = getMonthName(dateSplited[1]);

  const day = helperNumber.toPersianNum(dateSplited[2]);

  return " " + day + " " + month + " " + year;
};

const getMonthName = (numberMonth) => {
  const month = [
    "فروردین",
    "اردیبهشت",
    "خرداد",

    "تیر",
    "مرداد",
    "شهریور",

    "مهر",
    "آبان",
    "آذر",

    "دی",
    "بهمن",
    "اسفند",
  ];

  return month[numberMonth - 1];
};

const date = getDateNow();

export default function Nav() {
  useEffect(() => {
    if (document.getElementById("day-name-now") != null) {
      startTime();

      document.getElementById("day-name-now").innerHTML = getDayFullNamePer();
    }
  }, []);

  return (
    <nav className="main-header position-fixed w-100 navbar navbar-expand bg-white navbar-light border-bottom">
      <div className="d-flex w-100 justify-content-between align-items-center">
        <div className="d-flex nav-date-time" style={{ marginRight: "250px" }}>
          <div class="nav-item px-2">
            <a
              class="nav-link d-lg-none "
              id="push-menu-dashboard"
              data-widget="pushmenu"
              href="#"
            >
              <i class="fa fa-bars"></i>
            </a>
          </div>
          <div
            className="nav-item d-none d-lg-flex align-items-center px-3 py-2 "
            dir="ltr"
          >
            <span dir="rtl" className="pr-1 text-nowrap">
              {date}
            </span>
            <span className="text-nowrap px-1" id="day-name-now"></span>
            <span dir="rtl">امروز : </span>
          </div>
        </div>

        <div className="d-flex align-items-center  ">
          <div className="d-none d-lg-flex">
            <Link to="/help" className="btn btn-success">
              راهنمای گام به گام
            </Link>
          </div>
          <Charge />
          <User />
        </div>
      </div>
    </nav>
  );
}
